"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityReverseControls = exports.EntityReverseControlsDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var lodash_1 = require("lodash");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_modal_1 = require("../../hooks/use-modal");
var client_1 = require("@apollo/client");
var entity_reverse_field_dialog_1 = require("./entity-reverse-field-dialog");
var use_entities_1 = require("../../hooks/use-entities");
var use_lang_1 = require("../../hooks/use-lang");
var icon_button_1 = require("../../components/elements/icon-button");
var use_active_person_1 = require("../../hooks/use-active-person");
var current_user_can_1 = require("../../utils/current-user-can");
var cls = (0, utils_1.classNames)('entity-reverse-controls');
exports.EntityReverseControlsDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column; \n  "], ["\n    display: flex;\n    flex-direction: column; \n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "])))
});
var ReverseFieldDialogStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var CreateButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ReverseFieldDialog: (0, styled_components_1.default)(entity_reverse_field_dialog_1.EntityReverseFieldDialog)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ReverseFieldDialogStyles),
  CreateButton: (0, styled_components_1.default)(icon_button_1.CreateIconButton)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), CreateButtonStyles)
};
var EntityReverseControls = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity,
    reverseEntityTypeNames = props.reverseEntityTypeNames;
  var t = (0, use_lang_1.useLang)();
  var person = (0, use_active_person_1.useActivePerson)();
  var entities = (0, use_entities_1.useEntities)();
  var defn = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var client = (0, client_1.useApolloClient)();
  var modal = (0, use_modal_1.useModal)();
  var reversePositionFields = (0, lodash_1.pickBy)((defn === null || defn === void 0 ? void 0 : defn.form.reverseFields) || {}, function (field) {
    return (0, lodash_1.includes)(reverseEntityTypeNames, field.entityTypeName);
  });
  var reverseFormOnComplete = function (args) {
    modal.hide();
    client.cache.evict({
      id: "".concat(defn.name, ":").concat(entity.id)
    });
  };
  var controls = !!(0, lodash_1.size)(reversePositionFields) && (0, lodash_1.map)(reversePositionFields, function (field, fieldName) {
    var reverseDefn = entities[field.reverseEntityTypeName];
    if (reverseDefn) {
      if (!(0, current_user_can_1.personCanCreate)(person, reverseDefn.scopeSlug)) {
        return null;
      }
      return react_1.default.createElement(My.CreateButton, {
        key: "CREATE_".concat(fieldName),
        onClick: function () {
          modal.show(react_1.default.createElement(My.ReverseFieldDialog, {
            entity: entity,
            fieldName: fieldName,
            onCancel: function () {
              modal.hide();
            },
            onComplete: reverseFormOnComplete
          }));
        }
      }, t("Add ".concat(reverseDefn === null || reverseDefn === void 0 ? void 0 : reverseDefn.label)));
    }
  });
  if (!controls) {
    return null;
  }
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, controls);
};
exports.EntityReverseControls = EntityReverseControls;
exports.EntityReverseControls.defaultProps = exports.EntityReverseControlsDefaultProps;
exports.EntityReverseControls.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;